import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import type { ApplicationState } from 'core/redux/reducers/rootReducer';
import { formatDatetime } from 'core/utilities/dateFormat/dateFormat';
import React from 'react';
import { useSelector } from 'react-redux';
import type { SelectedColorScheme } from 'sequenceAnalyser/utilities/colors';

interface ComponentProps {
  alignment: string;
  range: string;
  colors?: SelectedColorScheme;
}

function PrintViewSummary({ alignment, range, colors }: ComponentProps) {
  const configuration = useSelector((state: ApplicationState) => state.configuration.configuration);
  const userName = useSelector((state: ApplicationState) => state.user.session?.user?.label);

  const data: Record<string, string | undefined> = {
    User: userName || '',
    'Creation Date': formatDatetime(new Date().toISOString(), configuration),
    Alignment: alignment,
    Range: range,
    'Color Scheme': colors ? colors.name : undefined,
    'Conservation Threshold': colors ? `${colors.conservation}%` : undefined,
  };

  return (
    <Box pt={6} pb={6} height="100vh">
      <Typography variant="h1" textAlign="center" fontSize={30}>
        Protein Sequence Report
      </Typography>
      <Box mt={6} />
      <Table
        style={{
          // Firefox fix to render borders within a table
          borderCollapse: 'unset',
        }}
      >
        <TableBody>
          {Object.keys(data).filter((key) => data[key] !== undefined).map((key) => (
            <TableRow key={`data-${key}`}>
              <TableCell width="35%">
                <Typography fontWeight="bold">{key}</Typography>
              </TableCell>
              <TableCell width="65%">
                <Typography>
                  {data[key]}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}

export default PrintViewSummary;
